const ROOTS = {
  agentNetworkService: '/agent-network-service',
  myJusan: '/myjusan/api/v1/contractor',
};

const endpoints = {
  agentNetworkService: {
    auth: {
      refresh: `${ROOTS.agentNetworkService}/auth/refresh`,
      login: `${ROOTS.agentNetworkService}/auth/login`,
    },
    leads: {
      root: `${ROOTS.agentNetworkService}/leads`,
      objectTypes: `${ROOTS.agentNetworkService}/leads/objectTypes`,
      item: (id: number) => `${ROOTS.agentNetworkService}/leads/${id}`,
      changeStatus: (id: number) =>
        `${ROOTS.agentNetworkService}/leads/${id}/changeStatus`,
    },
    partner: {
      root: `${ROOTS.agentNetworkService}/partner`,
      employees: {
        root: `${ROOTS.agentNetworkService}/partner/employees`,
        item: (id: number) =>
          `${ROOTS.agentNetworkService}/partner/employees/${id}`,
        consent: `${ROOTS.agentNetworkService}/partner/employees/consent`,
        restore: `${ROOTS.agentNetworkService}/password/restore`,
        newPassword: `${ROOTS.agentNetworkService}/password/new`,
        checkEmail: `${ROOTS.agentNetworkService}/partner/employees/checkEmail`,
        register: `${ROOTS.agentNetworkService}/partner/employees/register`,
        sendEmailConfirmation: `${ROOTS.agentNetworkService}/partner/employees/sendEmailConfirmation`,
      },
    },
    export: {
      root: `${ROOTS.agentNetworkService}/export`,
      id: (id: number) => `${ROOTS.agentNetworkService}/export/${id}`,
    },
  },
  employee: {
    searchEmployee: `${ROOTS.myJusan}/employee/search`,
  },
};

export default endpoints;
